import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'
import type { ProfileResponse } from '../types/api'

/**
 * Where a signed-in person lands: their own dashboard, which depends on who they are.
 *
 * <p>A parent's whole account is their children - "My children" is where they approve connections
 * and see activity - so that is where they start. Everyone else starts on their profile.
 *
 * <p>Every "you are now signed in" moment - sign-in, the email confirmation link, a registration
 * that signed straight in - goes to /dashboard rather than naming a page, so this is the one place
 * the rule lives.
 */
export function dashboardPathFor(profile: ProfileResponse | null): string {
  return profile?.entityKind === 'GUARDIAN' ? '/guardian' : '/profile'
}

export function DashboardRedirect() {
  const { profile, loading } = useAuth()
  // Carries a notice through - e.g. "some of your signup details could not be saved".
  const location = useLocation()
  if (loading || !profile) return null
  return <Navigate to={dashboardPathFor(profile)} replace state={location.state} />
}
